import { render, staticRenderFns } from "./CustDataViewPermissionContent.vue?vue&type=template&id=5bc2b405"
import script from "./CustDataViewPermissionContent.vue?vue&type=script&lang=js"
export * from "./CustDataViewPermissionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports